export default __webpack_public_path__ + "static/media/category_3.9673173f.png";